
<script>

    import config from "@/config/modals_config";

    /**
     * A functional component that renders the appropriate modal component
     * defined within the modals config
     */
    export default {

        name: "modal-wrapper",
        functional: true,

        props: [
            'name'
        ],

        render ( createElement, context) {
            // does the config have a component with this name?
            const inner = config[context.props.name];
            if ( inner ) {
                return createElement(
                    inner,
                    context.data,
                    context.children
                );
            }
        }
    }

</script>

